"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fanna": {
    "fd9cca88": [{
      "hkey": "b637d114",
      "slug": "fanna",
      "name": "Fanna",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-sottila": [{
      "hkey": "b637d114",
      "slug": "fanna",
      "name": "Fanna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "37a9b833": [{
      "hkey": "b637d114",
      "slug": "fanna",
      "name": "Fanna",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-di-strada": [{
      "hkey": "b637d114",
      "slug": "fanna",
      "name": "Fanna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;